<div class="tw-m-2 tw-p-2 tw-rounded-xl">
  <ng-container>
    <ng-container
      *ngTemplateOutlet="
        scenarioInfo;
        context: {
          title: scenarioTypeToPath[scenarioDetails?.scenarioType] | i18n,
          info: scenarioTypeToPath[scenarioDetails?.scenarioType] + 'Desc' | i18n,
          condition: scenarioDetails,
          isTitle: true,
        }
      "
    >
    </ng-container>

    <div
      class="tw-flex tw-flex-col tw-pt-3 tw-text-xs tw-leading-4"
      *ngIf="scenarioDetails?.helpInfo"
    >
      <ng-container
        *ngTemplateOutlet="
          scenarioInfo;
          context: {
            title: 'totalCurrentBalance' | i18n,
            info: scenarioDetails.helpInfo?.totalBalance | number: '1.2-2',
            condition: scenarioDetails.helpInfo?.totalBalance,
          }
        "
      >
      </ng-container>
      <ng-container
        *ngTemplateOutlet="
          scenarioInfo;
          context: {
            title: 'totalTransferAmount' | i18n,
            info: scenarioDetails.helpInfo?.transferAmount | number: '1.2-2',
            condition: scenarioDetails.helpInfo?.transferAmount,
          }
        "
      >
      </ng-container>
      <div
        class="tw-mb-4 tw-flex min-sm:tw-items-baseline tw-gap-6 sm:tw-flex-col"
        *ngIf="scenarioDetails.helpInfo?.transferToAccount"
      >
        <div class="tooltip-label tw-w-[150px] sm:tw-w-full">
          {{ "transferTo" | i18n }}
        </div>
        <ng-container
          *ngTemplateOutlet="
            accordionTooltip;
            context: {
              accounts: [scenarioDetails.helpInfo?.transferToAccount],
              isNotLeftPadding: true,
            }
          "
        >
        </ng-container>
      </div>
      <div
        class="tw-flex tw-flex-col"
        *ngIf="
          scenarioDetails.helpInfo?.transferFromAccount &&
          scenarioDetails.helpInfo.transferFromAccount.length > 0
        "
      >
        <div class="tw-mb-1 tw-flex tw-items-baseline tw-gap-6">
          <div class="tooltip-label tw-w-[150px] sm:tw-w-auto">
            {{ "transferFrom" | i18n }}
          </div>
          <ng-container
            *ngTemplateOutlet="
              existingAccount;
              context: {
                number: scenarioDetails.helpInfo.transferFromAccount.length,
              }
            "
          >
          </ng-container>
        </div>
        <ng-container
          *ngTemplateOutlet="
            accordionTooltip;
            context: { accounts: scenarioDetails.helpInfo.transferFromAccount }
          "
        >
        </ng-container>
      </div>
      <div class="tw-flex tw-flex-col" *ngIf="scenarioDetails.helpInfo?.existingAccounts">
        <div class="tw-mb-1 tw-flex tw-items-baseline tw-gap-6">
          <div class="tooltip-label tw-w-[150px] sm:tw-w-auto">{{ "currentAccount" | i18n }}</div>
          <ng-container
            *ngTemplateOutlet="
              existingAccount;
              context: {
                number: scenarioDetails.helpInfo.existingAccounts?.length,
              }
            "
          >
          </ng-container>
        </div>
        <ng-container
          *ngTemplateOutlet="
            accordionTooltip;
            context: { accounts: scenarioDetails.helpInfo.existingAccounts }
          "
        >
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #accordionTooltip let-accounts="accounts" let-isNotLeftPadding="isNotLeftPadding">
  <!-- Indented into the value column beside the labels: their tw-w-[150px] + tw-gap-6 (24px).
       Values inset their text tw-px-3, like app-accordion's title, so it all starts at one x. -->
  <div
    class="tw-flex tw-flex-col tw-gap-1 sm:tw-ml-0 tw-text-sm"
    [ngClass]="{ 'tw-ml-[174px]': !isNotLeftPadding, 'tw-w-full': isNotLeftPadding }"
  >
    <ng-container *ngFor="let account of accounts">
      <app-accordion
        [isClickable]="true"
        [contentTemplate]="accountDetails"
        collapseIcon="up-arrow"
        expandIcon="down-arrow"
        class="tw-w-full"
        customClass="tw-w-full tw-bg-color-surface-card tw-text-color-text-default"
      >
        <span title class="tw-w-[90%] tw-text-left">{{ getScenarioAccountInfo(account) }}</span>
      </app-accordion>

      <ng-template #accountDetails>
        <div class="tw-flex tw-items-baseline tw-gap-4 sm:tw-flex-col sm:tw-gap-0">
          <span class="tw-font-medium"> {{ "conditions" | i18n }}</span>
          <ul>
            <li
              class="tw-font-normal"
              *ngFor="let condition of getScenarioAccountConditions(account)"
            >
              {{ condition }}
            </li>
          </ul>
        </div>
        <div class="tw-mt-2 tw-flex tw-justify-between sm:tw-flex-col">
          <div class="tw-flex tw-gap-4 sm:tw-flex-col sm:tw-gap-0">
            <span class="tw-w-[60px] tw-font-medium sm:tw-w-full">{{ "lastReviewed" | i18n }}</span>
            <span class="tw-text-sm tw-font-normal" [innerHTML]="getLastCheckedDateMarkup(account)">
            </span>
          </div>
          <a
            href="{{ getUrl(account) }}"
            target="_blank"
            class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-bg-color-surface-elevated tw-px-6 tw-py-3 tw-font-medium tw-text-color-text-action hover:tw-no-underline sm:tw-w-full"
          >
            {{ "linkToSite" | i18n }}
            <svg class="tw-h-4 tw-w-4 tw-text-color-text-action">
              <use xlink:href="images/sprite.svg#link" />
            </svg>
          </a>
        </div>
      </ng-template>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #scenarioInfo
  let-title="title"
  let-info="info"
  let-condition="condition"
  let-isTitle="isTitle"
>
  <div class="tw-mb-4 tw-flex min-sm:tw-items-baseline tw-gap-6 sm:tw-flex-col" *ngIf="condition">
    <div class="tooltip-label tw-w-[150px] sm:tw-w-full">
      {{ title }}
    </div>
    <div
      class="tw-w-full tw-p-1 tw-px-3 tw-rounded-lg tw-flex tw-justify-between"
      [ngClass]="{
        'tw-bg-color-surface-card': !isTitle,
        'tw-text-color-text-secondary': isTitle,
        'tw-text-lg': !isTitle,
        'sm:tw-px-0': isTitle,
      }"
    >
      <span>
        {{ info }}
      </span>
      @if (!isTitle) {
        <span class="tw-text-color-text-secondary">
          {{ coreCurrency() }}
        </span>
      }
    </div>
  </div>
</ng-template>

<ng-template #existingAccount let-number="number">
  <div class="tw-flex tw-w-full tw-flex-col tw-px-3 sm:tw-px-0 sm:tw-text-right">
    {{ number }}
    {{ "existingAccount" | i18n }}{{ number > 1 ? "s" : "" }}
  </div>
</ng-template>
